import moment from "moment";
import { useContext } from "react";
import { AvisConstants } from "../../../../../data/avisConstants";
import {
  AvisField,
  AvisGrid,
  AvisSection,
} from "../../../../shared/components/form";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface ICreationOtherInfoProps {
  creationRegistered: string | undefined;
  creationStatus: string | undefined;
  musicalCreationName?: string;
  statusNotes?: string;
}

export function CreationOtherInfo(props: Readonly<ICreationOtherInfoProps>) {
  const { res } = useContext(AvisContext);
  const {
    creationRegistered,
    creationStatus,
    musicalCreationName,
    statusNotes,
  } = props;

  return (
    <AvisSection
      collapsable
      title={res("authors_Creation_Section_Other_Title")}
      textToDisplayKey="portal_RH_CreationCard_OtherInformation"
    >
      <AvisGrid>
        {typeof musicalCreationName != "undefined" && (
          <AvisField
            title={res("authors_Creation_Section_Other_label_MusicalCreation")}
            value={musicalCreationName}
          />
        )}
        <AvisField
          title={res("authors_Creation_Section_Other_label_CreationDate")}
          value={
            creationRegistered
              ? moment(creationRegistered).format(AvisConstants.date_format)
              : ""
          }
        />
        <AvisField
          title={res("authors_Creation_Section_Other_label_Status")}
          value={creationStatus}
        />
        <AvisField
          title={res("authors_Creation_Section_Other_label_StatusNotes")}
          value={statusNotes}
        />
      </AvisGrid>
    </AvisSection>
  );
}
